import { provide, reactive } from 'vue';

export default (multiple = false) => {
  const accordionState = reactive({
    openPanels: [],
    count: 0,
  });
  provide('isAccordionOpen', (id) => accordionState.openPanels.includes(id));
  provide('generateAccordionId', () => {
    accordionState.count += 1;
    return accordionState.count;
  });
  provide('toggleAccordionPanelById', (id) => {
    if (accordionState.openPanels.includes(id)) {
      accordionState.openPanels = accordionState.openPanels.filter(
        (openPanelId) => openPanelId !== id,
      );
    } else {
      if (multiple) {
        accordionState.openPanels.push(id);
      } else {
        accordionState.openPanels = [id];
      }
    }
  });
};
